<div class="complete-jobs-component"
     data-testid="complete-jobs-container">
  <div class="online-header"
       data-testid="ccm-completed-jobs-header-online">
    <div class="title"
         data-testid="ccm-text-completed-jobs-title">Completed BQ7s</div>
    <div class="icon-container">
      <online-indicator></online-indicator>
    </div>
  </div>
  <app-background-refresh-indicator [active]="isRefreshingInBackground()" />
  @if (online) {
    @if (dataLoaded) {
      @if (salesCommunityNames.length > 0) { <!--Completed Jobs-->
        <div class="complete-tab-content">
          <p-tabs [scrollable]="true"
                  [showNavigators]="true"
                  [value]="0"
                  class="complete-jobs-tabs"
                  data-testid="complete-jobs-tabs">
            <p-tablist data-testid="complete-jobs-tablist"
                       [className]="'complete-jobs-tab-list'"
                       (wheel)="onTabRowWheel($event)">
              @for ( salesCommunityName of salesCommunityNames; track $index){
                <p-tab [value]="$index"
                       [attr.data-testid]="'complete-jobs-tab-' + $index">{{salesCommunityName}}</p-tab>
              }
            </p-tablist>
            <p-tabpanels>
              @for ( salesCommunityName of salesCommunityNames; track $index){
                <p-tabpanel [value]="$index">
                  <div class="jobs-of-community"
                       data-testid="complete-jobs-community-list">
                    @for (jobsByDate of jobsByCommunity[salesCommunityName]; track $index){
                      <div class="jobs-of-date">
                        <h2 class="body-md-semibold completed-job-date">{{jobsByDate.date}}</h2>
                        <div class="completed-jobs-of-date">
                          @for (inspectionJob of jobsByDate.inspectionJobs; track $index){
                            <a class="job-item-button"
                               [href]="'/ccm/bq7/job/' + inspectionJob.id + '/report'"
                               (click)="navigateToJob(inspectionJob.id, $event)"
                               data-testid="complete-jobs-btn-job">
                              <div class="completed-job-item">
                                <div class="job-address">
                                  {{inspectionJob.lot.streetAddress + ", Lot " + inspectionJob.lot.lotBlock}}
                                </div>
                                <i class="pi pi-chevron-right job-item-chevron"></i>
                              </div>
                            </a>

                          }
                        </div>
                      </div>
                    }
                  </div>

                </p-tabpanel>
              }
            </p-tabpanels>
          </p-tabs>
        </div>
      } @else { <!--No Completed Jobs Message-->
        <div class="tab-offset">
          <div class="centered-container"
               data-testid="complete-jobs-container-empty">
            <div class="centered-icon">
              <img class="unavailable-img"
                   src="/assets/icons/history.svg" />
            </div>
            <div class="centered-text">
              <h2 class="unavailable-header">No Recent BQ7s</h2>
              <span class="unavailable-description body-md-regular">Completed ones will show here for 30 days</span>
            </div>
          </div>
        </div>
      }
    } @else { <!-- Skeleton Loader-->
      <div>
        <div class="tab-loader">
          <p-skeleton width="6rem"
                      height="1.5rem"></p-skeleton>
          <p-skeleton width="6rem"
                      height="1.5rem"></p-skeleton>
          <p-skeleton width="6rem"
                      height="1.5rem"></p-skeleton>
          <p-skeleton width="6rem"
                      height="1.5rem"></p-skeleton>
        </div>
      </div>
      <div>
        <div class="jobs-of-community skeleton-container"
             data-testid="complete-jobs-container-skeleton">
          <div class="jobs-of-date">
            <p-skeleton height="1rem"
                        width="6rem"></p-skeleton>
            <div class="completed-jobs-of-date">
              <p-skeleton height="4.5rem"
                          class="skeleton-item"></p-skeleton>
              <p-skeleton height="4.5rem"
                          class="skeleton-item"></p-skeleton>
              <p-skeleton height="4.5rem"
                          class="skeleton-item"></p-skeleton>
            </div>
          </div>
          <div class="jobs-of-date">
            <p-skeleton height="1rem"
                        width="6rem"></p-skeleton>
            <div class="completed-jobs-of-date">
              <p-skeleton height="4.5rem"
                          class="skeleton-item"></p-skeleton>
              <p-skeleton height="4.5rem"
                          class="skeleton-item"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    }
  } @else { <!--Offline Message-->
    <div class="tab-offset">
      <div class="centered-container"
           data-testid="complete-jobs-container-offline">
        <div class="centered-icon">
          <img class="unavailable-img"
               src="/assets/icons/cloudOffline.svg" />
        </div>
        <div class="centered-text">
          <h2 class="unavailable-header">You're Offline</h2>
          <span class="unavailable-description body-md-regular">Reconnect to view completed lots</span>
        </div>
      </div>
    </div>
  }
</div>